var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-structure-shape"},[(_vm.is_edit_mode)?_c('StandardDeleteButton',{staticClass:"project-structure-shape-delete",attrs:{"zoom":0.8},on:{"clickDelete":function($event){return _vm.$emit('clickDelete')}}}):_vm._e(),_c('div',{staticClass:"project-structure-shape-name"},[_vm._v(_vm._s(_vm.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }